module.exports = __webpack_public_path__ + "img/avatar3.863150b1.png";